import { Box, Text } from '@mantine/core'
import Link from 'next/link'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import ImageFallback from './image_fallback.js'
import Image from 'next/image'

const CarouselItem = ({
  posterUrl,
  id,
  uid,
  num,
  year,
  genre,
  title,
  type,
  hasUrl = false,
  score = null
}) => {
  const content = (
    <>
      <ImageFallback
        src={
          posterUrl
            ? `https://wsrv.nl/?url=${posterUrl}&w=400&output=webp&ll`
            : '/noimage.png'
        }
        fallbackSrc="/noimage.png"
        alt="movie poster"
        style={{
          objectFit: 'cover',
          borderRadius: '8px'
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0px -3px 0px 0px rgba(123,57,182,1) inset;',
          borderRadius: '8px'
        }}
      >
        <Box sx={{ position: 'absolute', top: 0, left: 0, padding: '5px' }}>
          <Text color="white" tt="uppercase" fw={500} size={10}>
            {genre} {genre && year && <span>|</span>} {year}
          </Text>
        </Box>
        {type === 'series' && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 10,
              padding: '5px',
              backgroundColor: 'rgba(123,57,182,1)',
              borderRadius: '0 0 5px 5px',
              display: 'flex',
              placeContent: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              width: '21px',
              height: '19px'
            }}
            w={21}
            h={19}
          >
            <Text color="white" size={10} fw={700} p={0}>
              TV
            </Text>
          </Box>
        )}
        {score !== null && score !== undefined && score > 0 && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: type === 'series' ? '35px' : '10px',
              backgroundColor: 'rgba(123,57,182,0.2)',
              color: 'rgba(123,57,182,1)',
              padding: '2px 6px',
              fontSize: '10px',
              fontWeight: '700',
              letterSpacing: '0.5px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              borderBottomLeftRadius: '4px',
              zIndex: 10
            }}
          >
            <Image src="/scorestar.png" width={10} height={10} alt="Score star" />
            {Number(score).toFixed(1)}/10
          </Box>
        )}
        <Box sx={{ position: 'absolute', bottom: 0, left: 0 }} pl={5}>
          <Text
            fw={800}
            color="rgba(123,57,182,1)"
            size="35px"
            sx={{ lineHeight: 0.9 }}
          >
            {num}
          </Text>
        </Box>
        <Box sx={{ position: 'absolute', bottom: 0, right: 0, padding: '5px' }}>
          {title && ( // Solo renderiza el título si no es null
            <Text color="white" tt="uppercase" fw={700} size={12}>
              {title.length > 30 ? title.substring(0, 30) + '...' : title}
            </Text>
          )}
        </Box>
      </Box>
    </>
  )

  return (
    <Box
      sx={{
        position: 'relative',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          transform: 'scale(1.01)'
        },
        height: '100%',
        borderRadius: '8px'
      }}
    >
      {hasUrl ? (
        <Link href={`/${type}/${id ? String(id).replace('/', '-') : uid}`}>
          {content}
        </Link>
      ) : (
        content
      )}
    </Box>
  )
}

CarouselItem.propTypes = {
  posterUrl: PropTypes.string,
  id: PropTypes.string.isRequired,
  num: PropTypes.number,
  ranking: PropTypes.string,
  hasUrl: PropTypes.bool,
  score: PropTypes.number
}

export default CarouselItem
